module.exports = __webpack_public_path__ + "static/media/img2-1.dbc2f498.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/agave/biosense/diff/img2-1.png
// module id = 1030
// module chunks = 3